module.exports = __webpack_public_path__ + "img/abyssal_blade.7d771c70.png";